// extracted by mini-css-extract-plugin
module.exports = {"borderRadius":"4px","headertablecontainer":"event-results-page__headertablecontainer____VryOj","resultstablecontainer":"event-results-page__resultstablecontainer____36SGV"};